<svg class="background" #background></svg>

<editable-text-view [textModel]="displayModel"
                    [placeholder]="placeholder"
                    (textChange)="onTextChanged($event)"
                    [style.left]="textOffsetLeft"
                    [style.top]="textOffsetTop"
>
</editable-text-view>
